<template>
    <div class="footer">
        <div class="footer_content">
            <div class="footer_left">
                <img :src="logo" style="margin:0" />
                <p style="letter-spacing:2px;">{{ $t("footer.gsmc") }}</p>
                <!-- <p>Copyright © 2012-2023 www.exchange.com All rights
                    reserved </p> -->
                <!-- <div>
                    <el-tooltip class="item" effect="dark" content="ceo@bitspaie.com" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://twitter.com/BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://medium.com/@BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://www.reddit.com/u/coinex" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                </div> -->
            </div>

            <div class="footer_right">
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.gsjj") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" to="/about-us">{{ $t("footer.gywm") }}</router-link>
                    </li>
                    <!-- <li>
                        <router-link target="_blank" :to="getUrl(1)">{{ $t("footer.jrwm") }}</router-link>
                    </li> -->
                    <li>
                        <router-link target="_blank" to="/announcement/0">{{ $t("footer.notice") }}</router-link>
                    </li>
                    <li class="wechatclick">
                        <!-- <poptip width="80" trigger="hover" placement="right">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                            <div slot="content">
                                <p style="text-align:center;">{{ $t("footer.zwkf") }}</p>
                            </div>
                        </poptip> -->
                        <el-tooltip class="item" effect="dark" :content="$t('footer.zwkf')" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.bzzx") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(2)">{{ $t("footer.xszn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(3)">{{ $t("footer.cjwt") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(4)">{{ $t("footer.jyzn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(5)">{{ $t("footer.bzzl") }}</router-link>
                    </li>
                </ul>
                <ul style="display:none">
                    <li class="footer_title">
                        <span>{{ $t("footer.tkxy") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(6)">{{ $t("footer.mztk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(7)">{{ $t("footer.ystk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(8)">{{ $t("footer.fwtk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(9)">{{ $t("footer.fltk") }}</router-link>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.lxwm") }}</span>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.customerEmail" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.kfyx") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.businessCooperation" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.swhz") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.currencyApplication" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.sbsq") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.complaintReport" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.tsjb") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logo: '',
            dalist: {}
        };
    },
    created: function () {
        this.getcontactusfindr()
    },
    computed: {

    },
    methods: {
        // 初始化币种余额
        getcontactusfindr(coin) {
            this.$http
                .post(this.host + "/uc/contact-us/find")
                .then(response => {
                    var res = response.body;
                    this.dalist = res.data
                });
        },
        getUrl(type) {
            if (type == 1) {
                return "/helpdetail?cate=6&id=39&cateTitle=" + this.$t("footer.jrwm");
            } else if (type == 2) {
                return "/helplist?cate=0&cateTitle=" + this.$t("footer.xszn");
            } else if (type == 3) {
                return "/helplist?cate=1&cateTitle=" + this.$t("footer.cjwt");
            } else if (type == 4) {
                return "/helplist?cate=2&cateTitle=" + this.$t("footer.jyzn");
            } else if (type == 5) {
                return "/helplist?cate=3&cateTitle=" + this.$t("footer.bzzl");
            } else if (type == 6) {
                return "/helpdetail?cate=5&id=2&cateTitle=" + this.$t("footer.mztk");
            } else if (type == 7) {
                return "/helpdetail?cate=5&id=3&cateTitle=" + this.$t("footer.ystk");
            } else if (type == 8) {
                return "/helpdetail?cate=5&id=5&cateTitle=" + this.$t("footer.fwtk");
            } else if (type == 9) {
                return "/helpdetail?cate=5&id=38&cateTitle=" + this.$t("footer.fltk");
            }
        },
    }
}
</script>
<style scoped lang="scss">
.wechatclick .api2 {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
        img {
            width: 100px;
        }

        span {
            display: block;
            color: #333;
            text-align: center;
        }
    }
}

.footer {
    margin-top: -10px;
    width: 100%;
    overflow: hidden;
    // margin-top: -200px;

    .footer_content {
        // margin-top: 60px;
        height: 150px;
        padding: 60px 10%;
        color: #53575c;
        color: rgba(255, 255, 255, 0.8);
        background: #192330;

        .footer_left {
            float: left;
            font-size: 14px;
        }

        .footer_right {
            float: right;
            text-align: left;
        }

        .footer_right ul {
            float: left;
            margin: 0 30px;
        }

        .footer_right ul li {
            list-style-type: none;
        }

        .footer_right ul li a {
            color: #828ea1;
            line-height: 30px;
            display: block;
            font-size: 12px;
            text-decoration: none;
        }

        .footer_right ul li a:hover {
            color: #ffffff;
        }


    }
}
</style>
<template>
    <div class="footer">
        <div class="footer_content">
            <div class="footer_left">
                <img :src="logo" style="margin:0" />
                <p style="letter-spacing:2px;">{{ $t("footer.gsmc") }}</p>
                <!-- <p>Copyright © 2012-2023 www.exchange.com All rights
                    reserved </p> -->
                <!-- <div>
                    <el-tooltip class="item" effect="dark" content="ceo@bitspaie.com" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://twitter.com/BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://medium.com/@BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://www.reddit.com/u/coinex" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                </div> -->
            </div>

            <div class="footer_right">
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.gsjj") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" to="/about-us">{{ $t("footer.gywm") }}</router-link>
                    </li>
                    <!-- <li>
                        <router-link target="_blank" :to="getUrl(1)">{{ $t("footer.jrwm") }}</router-link>
                    </li> -->
                    <li>
                        <router-link target="_blank" to="/announcement/0">{{ $t("footer.notice") }}</router-link>
                    </li>
                    <li class="wechatclick">
                        <!-- <poptip width="80" trigger="hover" placement="right">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                            <div slot="content">
                                <p style="text-align:center;">{{ $t("footer.zwkf") }}</p>
                            </div>
                        </poptip> -->
                        <el-tooltip class="item" effect="dark" :content="$t('footer.zwkf')" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.bzzx") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(2)">{{ $t("footer.xszn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(3)">{{ $t("footer.cjwt") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(4)">{{ $t("footer.jyzn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(5)">{{ $t("footer.bzzl") }}</router-link>
                    </li>
                </ul>
                <ul style="display:none">
                    <li class="footer_title">
                        <span>{{ $t("footer.tkxy") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(6)">{{ $t("footer.mztk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(7)">{{ $t("footer.ystk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(8)">{{ $t("footer.fwtk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(9)">{{ $t("footer.fltk") }}</router-link>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.lxwm") }}</span>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.customerEmail" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.kfyx") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.businessCooperation" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.swhz") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.currencyApplication" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.sbsq") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.complaintReport" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.tsjb") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logo: '',
            dalist: {}
        };
    },
    created: function () {
        this.getcontactusfindr()
    },
    computed: {

    },
    methods: {
        // 初始化币种余额
        getcontactusfindr(coin) {
            this.$http
                .post(this.host + "/uc/contact-us/find")
                .then(response => {
                    var res = response.body;
                    this.dalist = res.data
                });
        },
        getUrl(type) {
            if (type == 1) {
                return "/helpdetail?cate=6&id=39&cateTitle=" + this.$t("footer.jrwm");
            } else if (type == 2) {
                return "/helplist?cate=0&cateTitle=" + this.$t("footer.xszn");
            } else if (type == 3) {
                return "/helplist?cate=1&cateTitle=" + this.$t("footer.cjwt");
            } else if (type == 4) {
                return "/helplist?cate=2&cateTitle=" + this.$t("footer.jyzn");
            } else if (type == 5) {
                return "/helplist?cate=3&cateTitle=" + this.$t("footer.bzzl");
            } else if (type == 6) {
                return "/helpdetail?cate=5&id=2&cateTitle=" + this.$t("footer.mztk");
            } else if (type == 7) {
                return "/helpdetail?cate=5&id=3&cateTitle=" + this.$t("footer.ystk");
            } else if (type == 8) {
                return "/helpdetail?cate=5&id=5&cateTitle=" + this.$t("footer.fwtk");
            } else if (type == 9) {
                return "/helpdetail?cate=5&id=38&cateTitle=" + this.$t("footer.fltk");
            }
        },
    }
}
</script>
<style scoped lang="scss">
.wechatclick .api2 {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
        img {
            width: 100px;
        }

        span {
            display: block;
            color: #333;
            text-align: center;
        }
    }
}

.footer {
    width: 100%;
    overflow: hidden;
    // margin-top: -200px;

    .footer_content {
        // margin-top: 60px;
        height: 150px;
        padding: 60px 10%;
        color: #53575c;
        color: rgba(255, 255, 255, 0.8);
        background: #192330;

        .footer_left {
            float: left;
            font-size: 14px;
        }

        .footer_right {
            float: right;
            text-align: left;
        }

        .footer_right ul {
            float: left;
            margin: 0 30px;
        }

        .footer_right ul li {
            list-style-type: none;
        }

        .footer_right ul li a {
            color: #828ea1;
            line-height: 30px;
            display: block;
            font-size: 12px;
            text-decoration: none;
        }

        .footer_right ul li a:hover {
            color: #ffffff;
        }


    }
}
</style>
<template>
    <div class="footer">
        <div class="footer_content">
            <div class="footer_left">
                <img :src="logo" style="margin:0" />
                <p style="letter-spacing:2px;">{{ $t("footer.gsmc") }}</p>
                <!-- <p>Copyright © 2012-2023 www.exchange.com All rights
                    reserved </p> -->
                <!-- <div>
                    <el-tooltip class="item" effect="dark" content="ceo@bitspaie.com" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://twitter.com/BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://medium.com/@BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://www.reddit.com/u/coinex" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                </div> -->
            </div>

            <div class="footer_right">
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.gsjj") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" to="/about-us">{{ $t("footer.gywm") }}</router-link>
                    </li>
                    <!-- <li>
                        <router-link target="_blank" :to="getUrl(1)">{{ $t("footer.jrwm") }}</router-link>
                    </li> -->
                    <li>
                        <router-link target="_blank" to="/announcement/0">{{ $t("footer.notice") }}</router-link>
                    </li>
                    <li class="wechatclick">
                        <!-- <poptip width="80" trigger="hover" placement="right">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                            <div slot="content">
                                <p style="text-align:center;">{{ $t("footer.zwkf") }}</p>
                            </div>
                        </poptip> -->
                        <el-tooltip class="item" effect="dark" :content="$t('footer.zwkf')" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.bzzx") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(2)">{{ $t("footer.xszn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(3)">{{ $t("footer.cjwt") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(4)">{{ $t("footer.jyzn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(5)">{{ $t("footer.bzzl") }}</router-link>
                    </li>
                </ul>
                <ul style="display:none">
                    <li class="footer_title">
                        <span>{{ $t("footer.tkxy") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(6)">{{ $t("footer.mztk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(7)">{{ $t("footer.ystk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(8)">{{ $t("footer.fwtk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(9)">{{ $t("footer.fltk") }}</router-link>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.lxwm") }}</span>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.customerEmail" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.kfyx") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.businessCooperation" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.swhz") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.currencyApplication" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.sbsq") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.complaintReport" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.tsjb") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logo: '',
            dalist: {}
        };
    },
    created: function () {
        this.getcontactusfindr()
    },
    computed: {

    },
    methods: {
        // 初始化币种余额
        getcontactusfindr(coin) {
            this.$http
                .post(this.host + "/uc/contact-us/find")
                .then(response => {
                    var res = response.body;
                    this.dalist = res.data
                });
        },
        getUrl(type) {
            if (type == 1) {
                return "/helpdetail?cate=6&id=39&cateTitle=" + this.$t("footer.jrwm");
            } else if (type == 2) {
                return "/helplist?cate=0&cateTitle=" + this.$t("footer.xszn");
            } else if (type == 3) {
                return "/helplist?cate=1&cateTitle=" + this.$t("footer.cjwt");
            } else if (type == 4) {
                return "/helplist?cate=2&cateTitle=" + this.$t("footer.jyzn");
            } else if (type == 5) {
                return "/helplist?cate=3&cateTitle=" + this.$t("footer.bzzl");
            } else if (type == 6) {
                return "/helpdetail?cate=5&id=2&cateTitle=" + this.$t("footer.mztk");
            } else if (type == 7) {
                return "/helpdetail?cate=5&id=3&cateTitle=" + this.$t("footer.ystk");
            } else if (type == 8) {
                return "/helpdetail?cate=5&id=5&cateTitle=" + this.$t("footer.fwtk");
            } else if (type == 9) {
                return "/helpdetail?cate=5&id=38&cateTitle=" + this.$t("footer.fltk");
            }
        },
    }
}
</script>
<style scoped lang="scss">
.wechatclick .api2 {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
        img {
            width: 100px;
        }

        span {
            display: block;
            color: #333;
            text-align: center;
        }
    }
}

.footer {
    width: 100%;
    overflow: hidden;
    // margin-top: -200px;

    .footer_content {
        // margin-top: 60px;
        height: 150px;
        padding: 60px 10%;
        color: #53575c;
        color: rgba(255, 255, 255, 0.8);
        background: #192330;

        .footer_left {
            float: left;
            font-size: 14px;
        }

        .footer_right {
            float: right;
            text-align: left;
        }

        .footer_right ul {
            float: left;
            margin: 0 20px;
        }

        .footer_right ul li {
            list-style-type: none;
        }

        .footer_right ul li a {
            color: #828ea1;
            line-height: 30px;
            display: block;
            font-size: 12px;
            text-decoration: none;
        }

        .footer_right ul li a:hover {
            color: #ffffff;
        }


    }
}
</style>
<template>
    <div class="footer">
        <div class="footer_content">
            <div class="footer_left">
                <img :src="logo" style="margin:0" />
                <p style="letter-spacing:2px;">{{ $t("footer.gsmc") }}</p>
                <!-- <p>Copyright © 2012-2023 www.exchange.com All rights
                    reserved </p> -->
                <!-- <div>
                    <el-tooltip class="item" effect="dark" content="ceo@bitspaie.com" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://twitter.com/BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://medium.com/@BIPPAX" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="https://www.reddit.com/u/coinex" placement="top">
                        <i class="el-icon-s-promotion"></i>
                    </el-tooltip>
                </div> -->
            </div>

            <div class="footer_right">
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.gsjj") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" to="/about-us">{{ $t("footer.gywm") }} &nbsp;&nbsp;
                            V 1.0.2</router-link>
                    </li>
                    <!-- <li>
                        <router-link target="_blank" :to="getUrl(1)">{{ $t("footer.jrwm") }}</router-link>
                    </li> -->
                    <li>
                        <router-link target="_blank" to="/announcement/0">{{ $t("footer.notice") }}</router-link>
                    </li>
                    <li class="wechatclick">
                        <!-- <poptip width="80" trigger="hover" placement="right">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                            <div slot="content">
                                <p style="text-align:center;">{{ $t("footer.zwkf") }}</p>
                            </div>
                        </poptip> -->
                        <el-tooltip class="item" effect="dark" :content="$t('footer.zwkf')" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.apidoc") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.bzzx") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(2)">{{ $t("footer.xszn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(3)">{{ $t("footer.cjwt") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(4)">{{ $t("footer.jyzn") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(5)">{{ $t("footer.bzzl") }}</router-link>
                    </li>
                </ul>
                <ul style="display:none">
                    <li class="footer_title">
                        <span>{{ $t("footer.tkxy") }}</span>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(6)">{{ $t("footer.mztk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(7)">{{ $t("footer.ystk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(8)">{{ $t("footer.fwtk") }}</router-link>
                    </li>
                    <li>
                        <router-link target="_blank" :to="getUrl(9)">{{ $t("footer.fltk") }}</router-link>
                    </li>
                </ul>
                <ul>
                    <li class="footer_title">
                        <span>{{ $t("footer.lxwm") }}</span>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.customerEmail" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.kfyx") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.businessCooperation" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.swhz") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.currencyApplication" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.sbsq") }}</a>
                        </el-tooltip>
                    </li>
                    <li class="wechatclick">
                        <el-tooltip class="item" effect="dark" :content="dalist.complaintReport" placement="left">
                            <a href="javascript:;" class="wechat">{{ $t("footer.tsjb") }}</a>
                        </el-tooltip>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logo: '',
            dalist: {}
        };
    },
    created: function () {
        this.getcontactusfindr()
    },
    computed: {

    },
    methods: {
        // 初始化币种余额
        getcontactusfindr(coin) {
            this.$http
                .post(this.host + "/uc/contact-us/find")
                .then(response => {
                    var res = response.body;
                    this.dalist = res.data
                });
        },
        getUrl(type) {
            if (type == 1) {
                return "/helpdetail?cate=6&id=39&cateTitle=" + this.$t("footer.jrwm");
            } else if (type == 2) {
                return "/helplist?cate=0&cateTitle=" + this.$t("footer.xszn");
            } else if (type == 3) {
                return "/helplist?cate=1&cateTitle=" + this.$t("footer.cjwt");
            } else if (type == 4) {
                return "/helplist?cate=2&cateTitle=" + this.$t("footer.jyzn");
            } else if (type == 5) {
                return "/helplist?cate=3&cateTitle=" + this.$t("footer.bzzl");
            } else if (type == 6) {
                return "/helpdetail?cate=5&id=2&cateTitle=" + this.$t("footer.mztk");
            } else if (type == 7) {
                return "/helpdetail?cate=5&id=3&cateTitle=" + this.$t("footer.ystk");
            } else if (type == 8) {
                return "/helpdetail?cate=5&id=5&cateTitle=" + this.$t("footer.fwtk");
            } else if (type == 9) {
                return "/helpdetail?cate=5&id=38&cateTitle=" + this.$t("footer.fltk");
            }
        },
    }
}
</script>
<style scoped lang="scss">
.wechatclick .api2 {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
        img {
            width: 100px;
        }

        span {
            display: block;
            color: #333;
            text-align: center;
        }
    }
}

.footer {
    width: 100%;
    overflow: hidden;
    // margin-top: -200px;

    .footer_content {
        // margin-top: 60px;
        height: 150px;
        padding: 60px 10%;
        color: #53575c;
        color: rgba(255, 255, 255, 0.8);
        background: #172636;

        .footer_left {
            float: left;
            font-size: 14px;
        }

        .footer_right {
            float: right;
            text-align: left;
        }

        .footer_right ul {
            float: left;
            margin: 0 20px;
        }

        .footer_right ul li {
            list-style-type: none;
        }

        .footer_right ul li a {
            color: #828ea1;
            line-height: 30px;
            display: block;
            font-size: 12px;
            text-decoration: none;
        }

        .footer_right ul li a:hover {
            color: #ffffff;
        }


    }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue